import * as React from 'react';

import { FIELD_PATHS, OTHER_OPTIONS } from '@funnels/constants';
import { AssetEntityIndex } from '@funnels/types';

import { AutoCompleteInputField, StringDisplay } from '../../Fields';
import loadLenders from '../_common/loadLenders';
import { EditableViewProps, FunnelViewProps, StringReadOnlyViewProps } from '../types';

interface FinancialInstitutionEditableViewProps extends EditableViewProps, AssetEntityIndex {
  label?: string;
  placeholder?: string;
  validationFailMessage?: string;
  disableFailMessage?: boolean;
}
export const FinancialInstitutionEditableView = (props: FinancialInstitutionEditableViewProps) => {
  const {
    label,
    placeholder = 'Search for your institution',
    validationFailMessage = 'Please select your current institution',
    disableFailMessage,
    isOptional,
    isDisabled,
    ...rest
  } = props;
  return (
    <AutoCompleteInputField
      name={FIELD_PATHS.ASSET_FINANCIAL_INSTITUTION(props.assetIndex)}
      dataSource={loadLenders}
      label={label}
      placeholder={placeholder}
      validationFailMessage={validationFailMessage}
      disableFailMessage={disableFailMessage}
      isOptional={isOptional}
      isDisabled={isDisabled}
      backupOption={OTHER_OPTIONS}
      isFullWidth
      {...rest}
    />
  );
};

interface FinancialInstitutionFunnelViewProps extends FunnelViewProps, AssetEntityIndex {
  label?: string;
  placeholder?: string;
  validationFailMessage?: string;
}
export const FinancialInstitutionFunnelView = (props: FinancialInstitutionFunnelViewProps) => {
  const {
    isDisabled,
    label = 'Who is the account with?',
    placeholder = 'Search for your institution',
    validationFailMessage = 'Please select your current institution',
  } = props;
  return (
    <AutoCompleteInputField
      name={FIELD_PATHS.ASSET_FINANCIAL_INSTITUTION(props.assetIndex)}
      dataSource={loadLenders}
      label={label}
      placeholder={placeholder}
      validationFailMessage={validationFailMessage}
      backupOption={OTHER_OPTIONS}
      isDisabled={isDisabled}
      isFullWidth
    />
  );
};

interface FinancialInstitutionReadOnlyProps extends StringReadOnlyViewProps {
  title?: string;
}
export const FinancialInstitutionReadOnlyView = (props: FinancialInstitutionReadOnlyProps) => (
  <StringDisplay {...props} />
);
